/* Wrist Bro — quiz funnel controller */
(function () {
  "use strict";

  function init(root) {
    var cfgEl = root.querySelector("[data-wbxq-config]");
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }

    var steps = Array.prototype.slice.call(
      root.querySelectorAll("[data-wbxq-step]"),
    );
    var bar = root.querySelector("[data-wbxq-bar]");
    var answers = {};
    var current = 0;
    var questionSteps = steps.filter(function (s) {
      return s.getAttribute("data-wbxq-step") === "question";
    }).length;

    function show(i) {
      current = i;
      steps.forEach(function (s, j) {
        s.classList.toggle("is-active", i === j);
      });
      var answered = 0;
      for (var j = 0; j < i; j++) {
        if (steps[j].getAttribute("data-wbxq-step") === "question") answered++;
      }
      if (bar) {
        var pct = Math.min(100, Math.round((answered / questionSteps) * 100));
        bar.style.width = Math.max(6, pct) + "%";
      }
      var counter = root.querySelector("[data-wbxq-count]");
      if (counter) {
        var kind = steps[i].getAttribute("data-wbxq-step");
        if (kind === "question") {
          counter.textContent =
            "Question " + (answered + 1) + " of " + questionSteps;
          counter.hidden = false;
        } else if (kind === "info") {
          counter.textContent = "Quick note, nearly there";
          counter.hidden = false;
        } else {
          counter.hidden = true;
        }
      }
      if (steps[i].getAttribute("data-wbxq-step") === "analyzing") {
        setTimeout(function () {
          buildResult();
          next();
        }, 1900);
      }
    }

    function next() {
      if (current < steps.length - 1) show(current + 1);
    }

    root.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-wbxq-opt]");
      if (opt) {
        var step = opt.closest("[data-wbxq-step]");
        var key = step.getAttribute("data-wbxq-key");
        var multi = step.getAttribute("data-wbxq-multi") === "true";
        var val = opt.getAttribute("data-wbxq-opt");
        if (multi) {
          opt.classList.toggle("is-selected");
          var chosen = [];
          step
            .querySelectorAll("[data-wbxq-opt].is-selected")
            .forEach(function (el) {
              chosen.push(el.getAttribute("data-wbxq-opt"));
            });
          answers[key] = chosen;
        } else {
          step.querySelectorAll("[data-wbxq-opt]").forEach(function (el) {
            el.classList.remove("is-selected");
          });
          opt.classList.add("is-selected");
          answers[key] = val;
          setTimeout(next, 260);
        }
        return;
      }
      if (e.target.closest("[data-wbxq-next]")) {
        e.preventDefault();
        next();
        return;
      }
      if (e.target.closest("[data-wbxq-back]")) {
        e.preventDefault();
        if (current > 0) show(current - 1);
        return;
      }
      /* Question cards advance on tap, so people tap the info card too
         (Clarity showed repeated dead clicks there). Honor that. */
      var infoStep = e.target.closest('[data-wbxq-step="info"]');
      if (infoStep && infoStep.classList.contains("is-active")) {
        next();
      }
    });

    function pickProfile() {
      var where = answers.where;
      if (where === "fingers") return cfg.profiles.median;
      if (where === "pinky") return cfg.profiles.ulnar;
      if (where === "burning") return cfg.profiles.nerve;
      return cfg.profiles[answers.when] || cfg.profiles.random;
    }

    function buildResult() {
      var p = pickProfile();
      var both = answers.hands === "both";
      var title = root.querySelector("[data-wbxq-result-title]");
      var body = root.querySelector("[data-wbxq-result-body]");
      var recoName = root.querySelector("[data-wbxq-reco-name]");
      var recoPrice = root.querySelector("[data-wbxq-reco-price]");
      var recoNote = root.querySelector("[data-wbxq-reco-note]");
      if (title)
        title.innerHTML = p.title.replace(/\*([^*]+)\*/g, "<em>$1</em>");
      if (body) {
        var extras = [];
        if (answers.sleep && answers.sleep !== "no")
          extras.push(cfg.sleep_line);
        var ctx = answers.context || [];
        if (ctx.indexOf("pregnant") > -1 && cfg.line_pregnant)
          extras.push(cfg.line_pregnant);
        if (ctx.indexOf("metabolic") > -1 && cfg.line_metabolic)
          extras.push(cfg.line_metabolic);
        if (ctx.indexOf("inflam") > -1 && cfg.line_inflam)
          extras.push(cfg.line_inflam);
        if (
          ["fingers", "pinky", "burning"].indexOf(answers.where) > -1 &&
          cfg.urgency_line
        )
          extras.push(cfg.urgency_line);
        body.textContent =
          p.body + (extras.length ? " " + extras.join(" ") : "");
      }
      /* The result screen carries more than one CTA (above and below the
         reviews), so every one of them needs the tier parameter. */
      var ctas = root.querySelectorAll(
        '[data-wbxq-step="result"] a.wbxq__btn:not(.wbxq__btn--ghost)',
      );
      Array.prototype.forEach.call(ctas, function (cta) {
        var base = cta.getAttribute("href").split("#");
        var joiner = base[0].indexOf("?") > -1 ? "&" : "?";
        if (base[0].indexOf("tier=") === -1) {
          cta.setAttribute(
            "href",
            base[0] +
              joiner +
              "tier=" +
              (both ? "2" : "1") +
              (base[1] ? "#" + base[1] : ""),
          );
        }
      });
      var pregLink = root.querySelector("[data-wbxq-preg-link]");
      if (pregLink)
        pregLink.hidden = (answers.context || []).indexOf("pregnant") === -1;
      if (both) {
        if (recoName) recoName.textContent = cfg.reco_double_name;
        if (recoPrice)
          recoPrice.innerHTML =
            cfg.double_price + " <s>" + cfg.double_compare + "</s>";
        if (recoNote) recoNote.textContent = cfg.reco_double_note;
      } else {
        if (recoName) recoName.textContent = cfg.reco_single_name;
        if (recoPrice)
          recoPrice.innerHTML =
            cfg.single_price + " <s>" + cfg.single_compare + "</s>";
        if (recoNote) recoNote.textContent = cfg.reco_single_note;
      }
    }

    show(0);
  }

  document.querySelectorAll("[data-wbxq]").forEach(init);
})();
